/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';

import { Select } from 'antd';
import PropTypes from 'prop-types';

import { SCHEDULE_TYPES } from 'constants/commons';

import IntlMessages from 'util/IntlMessages';

import { useScheduleSelector } from './hooks/useScheduleSelector';

const { Option } = Select;
const ALL_SCHS = 'all';
const SchedulesSelector = ({
  selectedSchedules,
  setSelected,
  setLoading,
  type = SCHEDULE_TYPES.schedule,
  // No default: `[]` means "every division of the org" for the query, while an absent prop
  // lets the hook fall back to the divisions selector.
  divisionIds,
  getPopupContainer = undefined,
  listHeight = undefined,
  initialScheduleIds = [],
  exactMatch = false,
}) => {
  const {
    loadingSchedules,
    handlePopupScroll,
    handleSearch,
    handleClear,
    onChange,
    options,
  } = useScheduleSelector({
    selectedSchedules,
    setSelected,
    setLoading,
    type,
    divisionIds,
    initialScheduleIds,
    exactMatch,
  });
  const getAllLabelOption = useCallback(() => {
    switch (type) {
      case SCHEDULE_TYPES.schedule:
        return 'schedulesSelector.allSchedules';
      case SCHEDULE_TYPES.task:
        return 'schedulesSelector.allTasks';
      case SCHEDULE_TYPES.checkpoint_route:
        return 'schedulesSelector.allCheckpointRoutes';
      default:
        return 'schedulesSelector.allSchedules';
    }
  }, [type]);

  return (
    <Select
      allowClear
      className="gx-m-0"
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ width: 400 }}
      maxTagCount={2}
      mode="multiple"
      onChange={onChange}
      onPopupScroll={handlePopupScroll}
      onSearch={handleSearch}
      onClear={handleClear}
      filterOption={false}
      showSearch
      value={selectedSchedules.selectedAll ? [ALL_SCHS] : Object.keys(selectedSchedules.byId)}
      loading={loadingSchedules}
      getPopupContainer={getPopupContainer}
      listHeight={listHeight}
      showArrow
    >
      <Option key={ALL_SCHS} value={ALL_SCHS}>
        <IntlMessages id={getAllLabelOption()} />
      </Option>
      {options}
    </Select>
  );
};

SchedulesSelector.propTypes = {
  selectedSchedules: PropTypes.shape({
    selectedAll: PropTypes.bool.isRequired,
    byId: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  setSelected: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  type: PropTypes.string,
  divisionIds: PropTypes.arrayOf(PropTypes.string),
  getPopupContainer: PropTypes.func,
  listHeight: PropTypes.number,
  initialScheduleIds: PropTypes.arrayOf(PropTypes.string),
};

export default React.memo(SchedulesSelector);
